import { micrositeFonts } from "@/components/microsite/fonts";
import { assetPrefix } from "@/vars/assetUrl";
import { Fragment } from "react";

type UseFontRenderProp = {
  textFont: string;
  style?: any;
};

export const useFontRender = ({ textFont, style = {} }: UseFontRenderProp) => {
  const font = micrositeFonts.find((item) => item.slug === textFont);
  const fontStyle: any = { fontFamily: font?.family || undefined, ...style };

  return { fontStyle, RenderFontStyle: <RenderStyle font={font} /> };
};

export const RenderStyle = ({ font }) => {
  if (!font) {
    return <Fragment />;
  }

  return (
    <link
      href={assetPrefix + "assets/fonts/" + font.slug + ".css"}
      rel="stylesheet"
    />
  );
};
